import * as React from 'react';

import { useNavigate } from 'react-router-dom';

/**
 * @returns A function that allows us to redirect to a specific url
 */
function useGoToURL() {
    const navigate = useNavigate();

    const goToURL = React.useCallback(
        (path: string, params: Record<string, string> = {}) => {
            let newPath: string | { pathname: string; search: string } = path;
            if (Object.keys(params).length) {
                const newParams = new URLSearchParams(params);
                newPath = { pathname: path, search: newParams.toString() };
            }
            navigate(newPath);
        },
        [navigate]
    );

    return goToURL;
}

export default useGoToURL;
